import type { PrefetchContext, PrefetchedDataProps } from '#src/shared/prefetch';

import type { MergedState } from '#src/app/shared/hooks/state';
import { useMergedStates } from '#src/app/shared/hooks/state';

import { prefetchPetitionGuidesPageDataFromApi, usePetitionGuidesPageDataFromApi } from './pageData';

export type PetitionGuidesPagePrefetchedContext = Readonly<{
	pageData: NonNullable<Parameters<typeof usePetitionGuidesPageDataFromApi>[0]>;
}>;

export type PetitionGuidesPageCombinedState = MergedState<ReturnType<typeof usePetitionGuidesPageDataFromApi>>;

export function usePageContext(prefetchedData?: PetitionGuidesPagePrefetchedContext): PetitionGuidesPageCombinedState {
	return useMergedStates(usePetitionGuidesPageDataFromApi(prefetchedData?.pageData, ''));
}

export async function prefetchPageContext(context: PrefetchContext): Promise<PetitionGuidesPagePrefetchedContext> {
	const [pageData] = await Promise.all([prefetchPetitionGuidesPageDataFromApi(context, '')]);

	return { pageData };
}

export type PetitionGuidesPagePrefetchedDataProps = PrefetchedDataProps<PetitionGuidesPagePrefetchedContext>;
